var _Object$defineProperty2 = require("@babel/runtime-corejs2/core-js/object/define-property");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime-corejs2/core-js/object/define-property", "@babel/runtime-corejs2/core-js/object/define-properties", "@babel/runtime-corejs2/core-js/object/get-own-property-descriptors", "@babel/runtime-corejs2/core-js/object/get-own-property-descriptor", "@babel/runtime-corejs2/core-js/object/get-own-property-symbols", "@babel/runtime-corejs2/core-js/object/keys", "core-js/modules/es6.regexp.to-string", "core-js/modules/es6.date.to-string", "core-js/modules/es6.object.to-string", "@babel/runtime-corejs2/core-js/reflect/construct", "@babel/runtime-corejs2/helpers/extends", "core-js/modules/es6.array.fill", "@babel/runtime-corejs2/core-js/parse-int", "@babel/runtime-corejs2/helpers/toConsumableArray", "@babel/runtime-corejs2/helpers/classCallCheck", "@babel/runtime-corejs2/helpers/createClass", "@babel/runtime-corejs2/helpers/assertThisInitialized", "@babel/runtime-corejs2/helpers/inherits", "@babel/runtime-corejs2/helpers/possibleConstructorReturn", "@babel/runtime-corejs2/helpers/getPrototypeOf", "@babel/runtime-corejs2/helpers/defineProperty", "core-js/modules/es6.array.find-index", "react", "prop-types", "classnames", "recompose", "../../../../breakpoints", "../../UI/Icon/ArrowLeft", "../../UI/Icon/ArrowRight", "../../css"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime-corejs2/core-js/object/define-property"), require("@babel/runtime-corejs2/core-js/object/define-properties"), require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors"), require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor"), require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols"), require("@babel/runtime-corejs2/core-js/object/keys"), require("core-js/modules/es6.regexp.to-string"), require("core-js/modules/es6.date.to-string"), require("core-js/modules/es6.object.to-string"), require("@babel/runtime-corejs2/core-js/reflect/construct"), require("@babel/runtime-corejs2/helpers/extends"), require("core-js/modules/es6.array.fill"), require("@babel/runtime-corejs2/core-js/parse-int"), require("@babel/runtime-corejs2/helpers/toConsumableArray"), require("@babel/runtime-corejs2/helpers/classCallCheck"), require("@babel/runtime-corejs2/helpers/createClass"), require("@babel/runtime-corejs2/helpers/assertThisInitialized"), require("@babel/runtime-corejs2/helpers/inherits"), require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"), require("@babel/runtime-corejs2/helpers/getPrototypeOf"), require("@babel/runtime-corejs2/helpers/defineProperty"), require("core-js/modules/es6.array.find-index"), require("react"), require("prop-types"), require("classnames"), require("recompose"), require("../../../../breakpoints"), require("../../UI/Icon/ArrowLeft"), require("../../UI/Icon/ArrowRight"), require("../../css"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.defineProperty, global.defineProperties, global.getOwnPropertyDescriptors, global.getOwnPropertyDescriptor, global.getOwnPropertySymbols, global.keys, global.es6Regexp, global.es6Date, global.es6Object, global.construct, global._extends, global.es6Array, global.parseInt, global.toConsumableArray, global.classCallCheck, global.createClass, global.assertThisInitialized, global.inherits, global.possibleConstructorReturn, global.getPrototypeOf, global.defineProperty, global.es6Array, global.react, global.propTypes, global.classnames, global.recompose, global.breakpoints, global.ArrowLeft, global.ArrowRight, global.css);
    global.NavBar = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _defineProperty2, _defineProperties, _getOwnPropertyDescriptors, _getOwnPropertyDescriptor, _getOwnPropertySymbols, _keys, _es6Regexp, _es6Date, _es6Object, _construct, _extends2, _es6Array, _parseInt2, _toConsumableArray2, _classCallCheck2, _createClass2, _assertThisInitialized2, _inherits2, _possibleConstructorReturn2, _getPrototypeOf2, _defineProperty3, _es6Array2, _react, _propTypes, _classnames, _recompose, _breakpoints, _ArrowLeft, _ArrowRight, _css) {
  "use strict";

  var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

  var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

  _Object$defineProperty2(_exports, "__esModule", {
    value: true
  });

  _exports.default = _exports.onClickCallback = _exports.getInitialSlide = void 0;
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _defineProperties = _interopRequireDefault(_defineProperties);
  _getOwnPropertyDescriptors = _interopRequireDefault(_getOwnPropertyDescriptors);
  _getOwnPropertyDescriptor = _interopRequireDefault(_getOwnPropertyDescriptor);
  _getOwnPropertySymbols = _interopRequireDefault(_getOwnPropertySymbols);
  _keys = _interopRequireDefault(_keys);
  _construct = _interopRequireDefault(_construct);
  _extends2 = _interopRequireDefault(_extends2);
  _parseInt2 = _interopRequireDefault(_parseInt2);
  _toConsumableArray2 = _interopRequireDefault(_toConsumableArray2);
  _classCallCheck2 = _interopRequireDefault(_classCallCheck2);
  _createClass2 = _interopRequireDefault(_createClass2);
  _assertThisInitialized2 = _interopRequireDefault(_assertThisInitialized2);
  _inherits2 = _interopRequireDefault(_inherits2);
  _possibleConstructorReturn2 = _interopRequireDefault(_possibleConstructorReturn2);
  _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf2);
  _defineProperty3 = _interopRequireDefault(_defineProperty3);
  _react = _interopRequireWildcard(_react);
  _propTypes = _interopRequireDefault(_propTypes);
  _classnames = _interopRequireDefault(_classnames);
  _ArrowLeft = _interopRequireDefault(_ArrowLeft);
  _ArrowRight = _interopRequireDefault(_ArrowRight);

  function ownKeys(object, enumerableOnly) { var keys = (0, _keys.default)(object); if (_getOwnPropertySymbols.default) { var symbols = (0, _getOwnPropertySymbols.default)(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor.default)(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3.default)(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors.default) { (0, _defineProperties.default)(target, (0, _getOwnPropertyDescriptors.default)(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2.default)(target, key, (0, _getOwnPropertyDescriptor.default)(source, key)); }); } } return target; }

  function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

  function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

  var getInitialSlide = function getInitialSlide(links) {
    var index = links.findIndex(function (el) {
      return el.selected;
    });
    return index > -1 ? index : 0;
  };

  _exports.getInitialSlide = getInitialSlide;

  var NextArrow = function NextArrow(_ref) {
    var onClick = _ref.onClick,
        stateClass = _ref.stateClass;
    return /*#__PURE__*/_react.default.createElement("button", {
      className: (0, _classnames.default)('next-slider__next', stateClass),
      onClick: onClick
    }, /*#__PURE__*/_react.default.createElement(_ArrowRight.default, {
      size: {
        default: 'xsmall',
        medium: 'medium'
      }
    }));
  };

  NextArrow.propTypes = {
    stateClass: _propTypes.default.string,
    onClick: _propTypes.default.func
  };

  var PrevArrow = function PrevArrow(_ref2) {
    var onClick = _ref2.onClick,
        stateClass = _ref2.stateClass;
    return /*#__PURE__*/_react.default.createElement("button", {
      className: (0, _classnames.default)('next-slider__prev', stateClass),
      onClick: onClick
    }, /*#__PURE__*/_react.default.createElement(_ArrowLeft.default, {
      size: {
        default: 'xsmall',
        medium: 'medium'
      }
    }));
  };

  PrevArrow.propTypes = {
    stateClass: _propTypes.default.string,
    onClick: _propTypes.default.func
  };

  var onClickCallback = function onClickCallback(element) {
    if (element instanceof global.Element) {
      element.focus();
    } else {
      var el = global.document.querySelector(element);

      if (el != null) {
        el.focus();
      }
    }
  };

  _exports.onClickCallback = onClickCallback;

  var NavBar = /*#__PURE__*/function (_Component) {
    (0, _inherits2.default)(NavBar, _Component);

    var _super = _createSuper(NavBar);

    function NavBar(props) {
      var _this;

      (0, _classCallCheck2.default)(this, NavBar);
      _this = _super.call(this, props);
      (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "onChangedMediaQuery", function () {
        _this.setState({
          rootOffsetWidth: _this.root.offsetWidth,
          slidesWidth: _this.computeSlidesWidth(),
          translateWidths: _this.getTranslateWidths()
        }, _this.scrollToSlide);
      });
      (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "onPrevArrowClick", function () {
        var selectedSlide = _this.state.selectedSlide;
        var _this$state = _this.state,
            rootOffsetWidth = _this$state.rootOffsetWidth,
            translateWidths = _this$state.translateWidths;
        var maxTranslateX = translateWidths[selectedSlide] + rootOffsetWidth / 2;
        var remainingWidths = translateWidths.slice(0, Math.max(0, selectedSlide));
        remainingWidths.forEach(function (translateX) {
          if (translateX <= maxTranslateX) {
            selectedSlide -= 1;
          }
        });

        _this.setState({
          selectedSlide: selectedSlide
        });
      });
      (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "onNextArrowClick", function () {
        var selectedSlide = _this.state.selectedSlide;
        var _this$state2 = _this.state,
            rootOffsetWidth = _this$state2.rootOffsetWidth,
            translateWidths = _this$state2.translateWidths;
        var maxTranslateX = translateWidths[selectedSlide] - rootOffsetWidth / 2;
        var remainingWidths = translateWidths.slice(selectedSlide + 1);
        remainingWidths.forEach(function (translateX) {
          if (translateX >= maxTranslateX) {
            selectedSlide += 1;
          }
        });

        _this.setState({
          selectedSlide: selectedSlide
        });
      });
      (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "onLinkClick", function (href, event) {
        var linkIndex = _this.props.links.findIndex(function (l) {
          return l.href === href;
        });

        if (linkIndex !== _this.state.selectedSlide) {
          _this.setState({
            selectedSlide: linkIndex
          }, _this.scrollToSlide);

          _this.props.onClick(event, onClickCallback);
        }
      });
      (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "onLinkFocus", function (link) {
        var currentLink = link.currentTarget;
        var currentLinkPosition = link.currentTarget.getBoundingClientRect();
        var selectedSlide = _this.state.selectedSlide;
        var _this$state3 = _this.state,
            rootOffsetWidth = _this$state3.rootOffsetWidth,
            translateWidths = _this$state3.translateWidths;
        var elementIntex = translateWidths.indexOf(-currentLink.offsetLeft);

        if (translateWidths[elementIntex] > translateWidths[selectedSlide]) {
          if (elementIntex === 0) {
            selectedSlide = elementIntex;
          } else {
            selectedSlide = elementIntex - 1;
          }
        }

        if (currentLinkPosition.x + currentLinkPosition.width > rootOffsetWidth) {
          selectedSlide += 2;
        }

        _this.setState({
          selectedSlide: selectedSlide
        });
      });
      (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "getTranslateWidths", function () {
        return (0, _toConsumableArray2.default)(_this.root.querySelectorAll('.next-navbar__slide')).map(function (el) {
          return -el.offsetLeft;
        });
      });
      (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "computeSlidesWidth", function () {
        var slides = (0, _toConsumableArray2.default)(_this.root.querySelectorAll('.next-navbar__slide'));
        var slidesLength = slides.length;
        return slides.reduce(function (accumulator, current, index) {
          return accumulator + current.offsetWidth - (slidesLength - 1 === index ? (0, _parseInt2.default)(global.getComputedStyle(current).paddingRight, 10) : 0);
        }, 0);
      });
      (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "scrollToSlide", function () {
        var _this$state4 = _this.state,
            selectedSlide = _this$state4.selectedSlide,
            touchDevice = _this$state4.touchDevice,
            translateWidths = _this$state4.translateWidths;

        if (touchDevice) {
          _this.root.querySelector('.next-navbar__slides').scrollLeft = Math.abs(translateWidths[selectedSlide]);
        }
      });
      (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "init", function (root) {
        _this.root = root;
      });
      _this.state = {
        serverSide: true,
        rootOffsetWidth: 0,
        selectedSlide: getInitialSlide(props.links),
        slidesWidth: 0,
        touchDevice: false,
        translateWidths: Array(props.links.length).fill(0) // SSR

      };
      return _this;
    }

    (0, _createClass2.default)(NavBar, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var _this2 = this;

        // because of SSR we have to test touchDevice client-side
        // once touchDevice state is updated and re-render is done,
        // we can update translateWidths state
        // (slides width is not the same for touch device and non-touched device)
        this.setState({
          serverSide: false,
          touchDevice: 'ontouchstart' in global && global.innerWidth <= _breakpoints.nextBreakpoints.LARGE
        }, function () {
          var links = _this2.props.links;

          if (links.length < 2) {
            return;
          }

          setTimeout(function () {
            _this2.setState({
              rootOffsetWidth: _this2.root.offsetWidth,
              slidesWidth: _this2.computeSlidesWidth(),
              translateWidths: _this2.getTranslateWidths()
            }, _this2.scrollToSlide);
          }, 250);
        });
        this.mediaQueryListS = global.matchMedia('(max-width: 767px)');
        this.mediaQueryListM = global.matchMedia('(min-width: 768px) and (max-width: 1199px)');
        this.mediaQueryListXL = global.matchMedia('(min-width: 1200px)');
        this.mediaQueryListS.addListener(this.onChangedMediaQuery);
        this.mediaQueryListM.addListener(this.onChangedMediaQuery);
        this.mediaQueryListXL.addListener(this.onChangedMediaQuery);
      }
    }, {
      key: "shouldComponentUpdate",
      value: function shouldComponentUpdate(nextProps, nextState) {
        // if no width offset, still not rendered client-side. No need to update.
        if (!nextState.rootOffsetWidth) {
          return false;
        } // always update when slide is changed


        if (this.state.selectedSlide !== nextState.selectedSlide) {
          return true;
        } // when switching media query...


        if (this.state.rootOffsetWidth === nextState.rootOffsetWidth && (0, _recompose.shallowEqual)(this.state.translateWidths, nextState.translateWidths)) {
          return false;
        } // else, default PureComponent check


        return !(0, _recompose.shallowEqual)(nextProps, this.props) || !(0, _recompose.shallowEqual)(nextState, this.state);
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.mediaQueryListS.removeListener(this.onChangedMediaQuery);
        this.mediaQueryListM.removeListener(this.onChangedMediaQuery);
        this.mediaQueryListXL.removeListener(this.onChangedMediaQuery);
      }
    }, {
      key: "render",
      value: function render() {
        var _this3 = this;

        var _this$state5 = this.state,
            rootOffsetWidth = _this$state5.rootOffsetWidth,
            selectedSlide = _this$state5.selectedSlide,
            slidesWidth = _this$state5.slidesWidth,
            serverSide = _this$state5.serverSide,
            touchDevice = _this$state5.touchDevice,
            translateWidths = _this$state5.translateWidths;
        var _this$props = this.props,
            labels = _this$props.labels,
            menuTitle = _this$props.menuTitle,
            className = _this$props.className,
            links = _this$props.links,
            renderLink = _this$props.renderLink;
        var needSliding = rootOffsetWidth < slidesWidth;
        var isConcertButton = className.indexOf('arte-concert') !== -1;
        var style = !touchDevice && needSliding ? {
          transform: "translateX(".concat(translateWidths[selectedSlide], "px)")
        } : {};

        if (links.length < 2) {
          return null;
        }

        var ariaProps = {
          'aria-label': menuTitle && menuTitle !== '' ? "".concat(labels.menu, " : ").concat(menuTitle) : "".concat(labels.menu, " : "),
          'aria-describedby': menuTitle && menuTitle !== '' ? '' : 'pageTitle'
        };
        return /*#__PURE__*/_react.default.createElement("nav", (0, _extends2.default)({
          role: "navigation",
          className: (0, _classnames.default)(className, 'next-navbar', isConcertButton ? (0, _css.showFor)('xlarge', 'flex') : '', {
            'server-side': serverSide
          }, {
            'touch-device': touchDevice
          }, {
            'single-item': links.length < 2
          })
        }, ariaProps), /*#__PURE__*/_react.default.createElement(PrevArrow, {
          stateClass: !needSliding || selectedSlide === 0 ? 'invisible' : '',
          onClick: this.onPrevArrowClick
        }), /*#__PURE__*/_react.default.createElement("div", {
          ref: this.init,
          className: "next-navbar__wrapper"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "next-navbar__slides",
          style: style
        }, links.map(function (link) {
          return renderLink(_objectSpread(_objectSpread({}, link), {}, {
            className: (0, _classnames.default)({
              'next-navbar__slide': true,
              'is-selected': !!link.selected
            }),
            key: "".concat(link.label, "-").concat(link.href),
            onClick: _this3.onLinkClick,
            onFocus: _this3.onLinkFocus
          }));
        }))), /*#__PURE__*/_react.default.createElement(NextArrow, {
          stateClass: !needSliding || selectedSlide === links.length - 1 ? 'invisible' : '',
          onClick: this.onNextArrowClick
        }));
      }
    }]);
    return NavBar;
  }(_react.Component);

  NavBar.propTypes = {
    className: _propTypes.default.string,
    labels: _propTypes.default.shape({
      menu: _propTypes.default.string.isRequired
    }),
    links: _propTypes.default.arrayOf(_propTypes.default.shape({
      href: _propTypes.default.string.isRequired,
      label: _propTypes.default.string.isRequired,
      selected: _propTypes.default.bool
    })).isRequired,
    menuTitle: _propTypes.default.string.isRequired,
    onClick: _propTypes.default.func,
    renderLink: _propTypes.default.func.isRequired
  };
  NavBar.defaultProps = {
    className: '',
    labels: {
      menu: 'Menu'
    },
    links: [],
    menuTitle: '',
    onClick: function onClick() {}
  };
  var _default = NavBar;
  _exports.default = _default;
});